<template>
  <div>
    <q-splitter :model-value="infPanelType > 0 && showSidePanel ? 80 : 100" vertical :separator-class="separatorClass" style="height: calc(100vh - 170px)">
      <template #before>
        <g-gantt-chart
          v-if="isDone"
          :chart-start="chartStartDateString"
          :chart-end="chartEndDateString"
          precision="day"
          bar-start="beginDate"
          bar-end="endDate"
        >
          <g-gantt-row
            v-for="(obj, index) in rowLabels"
            :key="obj.lbl"
            :label="obj.lbl"
            :bars="elementsPerRow[obj.lbl]"
          >
            <template #label>
              <div class="rowLabelDiv" :style="'background-color: ' + obj.bkcolor + '; color: ' + obj.fontcolor">
                <q-icon v-if="obj.icon" :name="obj.icon" class="rowicon"/>
                <span @click="clickLink(obj.link)" :class="{linkhover: obj.link}"> {{ obj.lbl }} </span>
                <q-icon v-if="obj.info" name="info" @click="clickLink(obj.info)" class="rowicon" :class="{linkhover: obj.info}"/>
              </div>
              <q-tooltip v-if="obj.tooltip">{{ obj.tooltip }}</q-tooltip>
            </template>

            <template #bar-label="{bar}">
              <q-icon v-if="bar.icon"  :name="bar.icon" class="gantticon"/>
              <span @click="clickLink(bar.link)" style="text-align: center; padding-left: 2px; padding-right: 2px" :class="{linkhover: bar.link}">
                <div style="font-size: 14px">{{ bar.title }}</div>
                <div v-if="bar.subtext" style="font-size: 11px">{{ bar.subtext }}</div>
              </span>
              <q-icon v-if="bar.info" name="info" @click="clickLink(bar.info)" class="gantticon" :class="{linkhover: bar.info}"/>
              <q-icon v-if="bar.infPanelLat && bar.infPanelLng" name="location_on" @click="setLocation(bar.infPanelLat, bar.infPanelLng)" class="gantticon" :class="{linkhover: bar.infPanelLat && bar.infPanelLng}"/>
            </template>
          </g-gantt-row>

          <template #bar-tooltip="{bar}">
            {{ bar.tooltip ? bar.tooltip: bar.beginDate + ' - ' + bar.endDate }}
          </template> 
        </g-gantt-chart>
      </template>

      <template #separator v-if="infPanelType > 0">
        <q-avatar color="primary" style="cursor: pointer" text-color="white" size="30px" :icon="showSidePanel ? 'keyboard_arrow_right' : 'keyboard_arrow_left'" @click.exact="toggleSideView()"/>
      </template>

      <template #after v-if="infPanelType > 0">
        <div style="height: calc(100vh - 170px); width: 100%">
          <g-map-map v-if="infPanelType == 1" :center="gmapCenter" style="height: calc(100vh - 170px); width: 100%" :zoom="10" map-type-id="terrain" class="chartmap"
              :options="{ disableDefaultUI: false, zoomControl: true, fullscreenControl: false, streetViewControl: false, mapTypeControl: false}">
            <g-map-marker :position="gmapCenter"/>
          </g-map-map>
        </div>
      </template>
    </q-splitter>
  </div>
</template>

<script>
import moment from "moment"
import { openURL } from 'quasar'

export default {
  name: "app",
  props: ['chartType', 'queryColumns', 'queryResult', 'height'],
  data() {
    return {
      data: safeParseJSON(this.$route.params.data),
      dateFormat: 'YYYY-MM-DD HH:mm',
      chartStartDate: moment(),
      chartStartDateString: null,
      chartEndDtate: moment(),
      chartEndDateString : null,
      rowLabels: [],
      elementsPerRow: {},
      infPanelType: 0,
      gmapCenter: {lat: 48.210033, lng: 16.363449},
      showSidePanel: false,
      separatorClass : "noSeparator",
      isDone: false
    }
  },
  watch: {
    queryResult() {
      this.init()
    }
  },
  methods: {
    init() {
      this.isDone = false
      for (let idx = 0; idx < this.queryResult.length; idx++) {
        let item = this.queryResult[idx]
        if(item.gt_chart_period_start && item.gt_chart_period_end && item.gt_prc_period_start && item.gt_prc_period_end && item.gt_res_title && item.gt_prc_title){

          if(idx == 0){
            this.chartStartDate = moment(item.gt_chart_period_start, this.dateFormat)
            this.chartEndDate = moment(item.gt_chart_period_end, this.dateFormat)
            if(item.gt_inf_type){
              this.infPanelType = item.gt_inf_type
            }
          }

          if(!this.rowLabels.find(e => e.lbl == item.gt_res_title)){
            this.rowLabels.push({lbl: item.gt_res_title,
                                icon: item.gt_res_icon,
                                link: item.gt_res_link, 
                                info: item.gt_res_infolink, 
                                bkcolor: item.gt_res_bkcolor ? item.gt_res_bkcolor : 'white', 
                                fontcolor: item.gt_res_fontcolor ? item.gt_res_fontcolor : 'black', 
                                tooltip: item.gt_res_hint})
          }
          if(!this.elementsPerRow[item.gt_res_title]){
            this.elementsPerRow[item.gt_res_title] = []
          }  

          let ganttElement = {}
          ganttElement.beginDate = item.gt_prc_period_start
          ganttElement.endDate = item.gt_prc_period_end
          ganttElement.ganttBarConfig = {
            id: idx,
            label: item.gt_prc_title,
            style: {     // arbitrary CSS styling for your bar
              background: item.gt_prc_bkcolor ? item.gt_prc_bkcolor : "#e09b69",
              color: item.gt_prc_fontcolor ? item.gt_prc_fontcolor: "white"
            }
          }
          ganttElement.title = item.gt_prc_title
          ganttElement.subtext = item.gt_prc_subtitle
          ganttElement.tooltip = item.gt_prc_hint
          ganttElement.icon = item.gt_prc_icon
          ganttElement.link = item.gt_prc_link
          ganttElement.info = item.gt_prc_infolink
          ganttElement.infPanelLat = item.gt_inf_center_lat
          ganttElement.infPanelLng = item.gt_inf_center_lng

          this.elementsPerRow[item.gt_res_title].push(ganttElement)
        }
      }
      if(this.rowLabels.length == 0){
        this.$q.dialog({
          title: "Keine Elemente sichtbar. Bitte die Ergebnis Deklarationen prüfen.",
          message: "Ergebniszeilen benötigen die Spalten gt_chart_period_start, gt_chart_period_end, gt_prc_period_start, gt_prc_period_end, gt_res_title und gt_prc_title"
        })
      } else {
        this.chartStartDateString = moment(this.chartStartDate).format('YYYY-MM-DD HH:mm')
        this.chartEndDateString = moment(this.chartEndDate).format('YYYY-MM-DD HH:mm')
        this.isDone = true
      }
    },

    clickLink(link){
      if(link){
        openURL(link)
      }
    },

    setLocation(gLat, gLng){
      this.gmapCenter.lat = parseFloat(gLat)
      this.gmapCenter.lng = parseFloat(gLng)
      this.showSidePanel = true
      this.separatorClass = ""
    },

    toggleSideView(){
      this.showSidePanel = !this.showSidePanel
      if(this.showSidePanel){
        this.separatorClass = ""
      } else {
        this.separatorClass = "noSeparator"
      }
    }
  },
  mounted() {
    this.init()
  }
};
</script>

<style lang="sass">
.noSeparator
  display: none

.rowicon
  font-size: 15px

.gantticon
  font-size: 25px

.g-gantt-row-label
  padding: 0px
  border-bottom-right-radius: 0px

.rowLabelDiv
  height: 24px
  line-height: 24px
  padding-left: 8px
  padding-right: 8px

.linkhover
  cursor: pointer
</style>
